// extracted by mini-css-extract-plugin
export default {"pageContent":"Layout_pageContent__Nx3cn"};